import { lazy } from 'react';
const TelefonosUtilesPage = lazy(() => import('../../pages/TelefonosUtiles'));

const contactRoutes = [
  {
    title: 'Teléfonos Útiles',
    path: 'contacto/telefonos',
    component: TelefonosUtilesPage,
    isPrivate: false,
  },
];

export default contactRoutes;
